import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'firebaseUser']),
    isProvider() {
      return this.firebaseUser.providerData[0].providerId !== 'password'
    },
    displayOnlyFirstName() {
      const splittedName = this.displayName.split(' ')
      let result = splittedName[0]
      if (splittedName.length > 1) {
        result += ` ${splittedName[1][0].toUpperCase()}.`
      }
      return result
    },
    displayName() {
      if (this.isProvider) return this.firebaseUser.displayName
      else if (this.user.name) return this.user.name
      return this.firebaseUser.email
    },
    avatarURL() {
      if (this.firebaseUser.photoURL) return this.firebaseUser.photoURL
      return null
    },
  },
}
